export default __webpack_public_path__ + "static/media/parcel-logo-purple.d5397931.png";